<!-- 课程管理 添加 -->
<template>
  <div class="form_box">
    <el-card class="box-card">
      <CourseForm @onCourseAddChangeSelect="setCourseAddData" ref="courseForm"></CourseForm>
      <div class="el-icon-circle-close closeIcon" @click="onClickClose"></div>
    </el-card>
    <el-card class="box-card" v-loading="loading" style="margin-top:10px">
      <el-button style="margin-top: 12px;" type="primary" @click="publish">发布</el-button>
    </el-card>
  </div>
</template>




<script>
import { courseAddApi } from "@/api/module/course/course";

import { CourseForm } from "@/views/module/course/comp/";

export default {
  name: "schedulingCourseadd",
  props:{
    timetype:{
      type: Number
    }
  },
  components: {
    CourseForm
  },
  data() {
    return {
      title :  "",
      teacher :  "",
      description :  "",
      loading :  false,
      sid :  "",
      status :  "",
      showStudyClassSelect :  true,
    }
  },

  methods:{

    init(){},

    onClickClose(){
      this.$emit("onClickClose")
    },


      // 关闭页面
    onCourseAddCompleted() {
      this.$emit("onCourseAddCompleted", 0);
    },
    // extend  获取子组件数据
    setCourseAddData(e) {
      this.title = e.title;
      this.teacher = e.teacher;
      this.description = e.description;
      this.sid = e.sid;
      this.showStudyClassSelect = e.showStudyClassSelect;
    },

    //
    //   初始化学习班并隐藏选择器
    //
    initStudyClassAndHideSelect(studyClassId) {
      console.log('schedulingCourseadd sid',studyClassId)
      this.$refs.courseForm.setStudyClassSelectHide();
      this.$refs.courseForm.setStudyclassId(studyClassId);
      this.sid = studyClassId;
    },

    // 发布
    publish() {
      this.loading = true;
      this.status = "0";
      this.addDemo();
    },

    addDemo() {
      let _this = this;
      if (!this.title) {
        this.$message.error("请填写课程名称！");
        this.loading = false;
        return false;
      }

      let title = this.title;
      let teacher = this.teacher;
      let description = this.description;
      let sid = this.sid;
      let status = this.status;
      let data = {
        title: title,
        description: description,
        teacher: teacher,
        sid: sid,
        status: status,
      };
      courseAddApi(data)
        .then((response) => {
          this.$message({
            message: "操作成功！",
            type: "success",
          });
          setTimeout(function () {
            _this.$emit("onSaveSuccess", data);
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}


</script>




<style scoped lang="scss">
.form_box {
  .box-card {
    position: relative;
    .closeIcon {
      position: absolute;
      top: 2%;
      right: 2%;
      font-size: 20px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .form_box__item {
    margin-bottom: 15px;
    font-size: 14px;
    color: #303133;
    span {
      margin-right: 50px;
      white-space: nowrap;
    }
    .form_box__item__input {
      margin-left: 0;
    }
  }
}
</style>

